import styled from 'styled-components'

export const Container = styled.div`
  padding: 24px;
  .lesson-counters {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 12px;
  }
  .lesson-counter {
    height: auto;
    padding: 16px;
    text-align: left;
    justify-content: flex-start;
    white-space: normal;
  }
  .lesson-filters {
    padding: 16px 0 0;
  }
  .lesson-filters .ant-form-item {
    margin-bottom: 12px;
  }
  .lesson-person {
    min-width: 100px;
  }
  .lesson-person .ant-typography {
    display: block;
  }
  @media (max-width: 768px) {
    padding: 12px;
  }
`
